import React from 'react'

import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { withRouter, Redirect } from 'react-router-dom'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { fetchPortal } from '../../../modules/portal-remote/portalService'
import { setPortal } from '../../../actions/portal'
import withParams from '../../../modules/router-manage/withParams'

const connectPortal = connect(
  ({ portal }) => ({
    portalID: portal._id,
  }),
  dispatch => ({
    actions: bindActionCreators({ setPortal }, dispatch),
  }),
)

export default function withCreateProtectedPortalRoute(WrappedComponent) {
  return compose(
    withRouter,
    withParams,
    connectPortal,
  )(
    class CreateProtectedPortalRoute extends React.Component {
      static propTypes = {
        hasPortal: PropTypes.bool,
        actions: PropTypes.object,
      }

      state = {
        portalID: null,
      }

      static getDerivedStateFromProps(props, state) {
        if (props.portalID !== state.portalID) {
          return {
            portalID: props.portalID,
          }
        }
        return null
      }

      componentDidMount() {
        //handle signin

        const { portalID } = this.props.params
        this.requestPortal(portalID)
      }

      requestPortal = async portalID => {
        try {
          const portal = await fetchPortal(portalID)
          this.props.actions.setPortal(portal)
        } catch (error) {
          this.setState({ error })
        }
      }
      render() {
        if (this.state.error) {
          return <Redirect to="/login" />
        }
        if (this.state.portalID) {
          return <WrappedComponent {...this.props} />
        }
        return <div> Loading </div>
      }
    },
  )
}



// WEBPACK FOOTER //
// ./src/components/templates/route-management/withCreateProtectedPortalRoute.js